import { useContext } from "react"
import { Field } from "formik"
import { DateTime } from "luxon"
import { FormContext } from "../../context/formContext"
import { Calendar } from "primereact/calendar"
import DescriptionTooltip from "./helpers/DescriptionTooltip"
import styles from "../../styles/Form.module.css"
import {
  DATE_SUBTYPES,
  resolveFieldSubtype,
} from "../../helpers/dateNormalization"

function getCalendarProps(field) {
  const subtype = resolveFieldSubtype(field)
  const isTimeOnly = subtype === DATE_SUBTYPES.TIME
  const isDateTime = subtype === DATE_SUBTYPES.DATETIME

  return {
    showTime: isTimeOnly || isDateTime,
    timeOnly: isTimeOnly,
    hourFormat: isTimeOnly || isDateTime ? "12" : undefined,
    monthNavigator: !isTimeOnly,
    yearNavigator: !isTimeOnly,
  }
}

export default function TypeDate({ field, block, index }) {
  const isRequired = JSON.parse(field.field_validation.required[0])
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false

  return (
    <div className={styles.field} style={{ order: index }}>
      <label className={styles.label} style={{ gap: "10px" }}>
        <span>
          {field.field_label}
          {isRequired && <span className={styles.asterisk}> *</span>}
        </span>
        {field.field_description && (
          <DescriptionTooltip
            fieldName={field.field_name}
            fieldDescription={field.field_description}
          />
        )}
      </label>
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <div className="p-icon-field p-icon-field-right">
              <Calendar
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={formikField.onBlur}
                maxDate={DateTime.local().endOf("day").toJSDate()}
                {...getCalendarProps(field)}
              />
              <span className="p-input-icon pi pi-calendar" />
            </div>
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
